import React, { useEffect, useState } from "react";
import "./GrabCertificate.css";
import EducationTopBar from "../topbar/EducationTopBar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import RecognizedBySection from "./RecognizedBySection";
import GrabCertificateHelpSection from "./GrabCertificateHelpSection";
import { motion } from "framer-motion";
import { Drawer, useMediaQuery, useTheme } from "@mui/material";
import MyTechProfile from "../TechProfile/MyTechProfile";
import CloseIcon from "@mui/icons-material/Close";
import DownloadCertificateModal from "./DownloadCertificateModal";
import CertificatePreviewModal from "./CertificatePreviewModal";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import { userRegistrationSaveEachCardAction } from "../../../actions/MyCertificates/certificatesAction";
import LinkedinTestimonialCarousel from "./LinkedinTestimonialCarousel";
import { getPricingOptionsAction } from "../../../actions/Pricing/pricingActions";
import { getUserRegion } from "../../../utils/change_time_format";
import { getCurrencySymbol } from "../../../utils/conversion";
import MySkeletonLoader from "../reusables/MySkeletonLoader";
import PaymentLoader from "../TechProfile/PaymentLoader";
import { paymentCreateDodoUrlAction } from "../../../actions/Payment/paymentAction";
import { APIRequestURI } from "../../../utils/api_request_uri";

const certificateImage =
  "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

// SVG Icons
const VerifiedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
);

const RedirectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />
  </svg>
);

const RightArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
  </svg>
);

function GrabCertificate() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const { pricingOption, loading } = useSelector(
    (state) => state.getPricingOptionsStore
  );
  const { data } = useSelector(
    (state) => state.userRegistrationEachCardSaveStore
  );
  const { dodoData } = useSelector((state) => state.paymentCreateDodoUrlStore);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const texts = [
    "2000+ Students have created their profile",
    "78% increased Hiring Chances",
    "500+ Recruiters View profile daily",
  ];

  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const history = useHistory();

  // Check if certificate URL exists
  const certificateUrl = data?.originalRegistration?.status === "completed";
  const hasCertificate = Boolean(certificateUrl);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(userRegistrationSaveEachCardAction());
  }, []);

  useEffect(() => {
    if (!hasCertificate) {
      dispatch(
        getPricingOptionsAction({
          eligibleItems: [
            {
              itemType: "Certification",
              itemId: data?.originalRegistration?.certification?._id,
            },
          ],
          country: getUserRegion(),
        })
      );
    }
  }, [data, hasCertificate]);

  useEffect(() => {
    if (dodoData) {
      window.location.href = dodoData.checkoutUrl;
    }
  }, [dodoData]);

  const toggleDrawer = (val) => {
    setOpen(val);
  };

  const handleDownloadCertificate = async () => {
    try {
      const response = await fetch(certificateUrl, {
        mode: "cors",
      });

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${userInfo?.firstName}_Certificate.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading certificate:", error);
    }
  };

  const handleOpenDownloadDialog = () => {
    if (hasCertificate) {
      // Show download modal directly
      setOpenDownloadDialog(true);
    } else {
      // Proceed with payment flow
      setIsProcessing(true);
      const URL = new APIRequestURI().getBaseRedirectURL();
      dispatch(
        paymentCreateDodoUrlAction({
          dodoProductId: pricingOption?.options?.[0]?.dodoProductId,
          currency: pricingOption?.options?.[0]?.currency,
          amount: pricingOption?.options?.[0]?.price,
          pricingId: pricingOption?.options?.[0]?.pricingId,
          returnUrl: `${URL}/payment/success`,
        })
      );
    }
  };

  const handleCloseDownloadDialog = () => {
    setOpenDownloadDialog(false);
  };

  const handleOpenPreview = () => {
    setOpenPreviewModal(true);
  };

  const handleClosePreview = () => {
    setOpenPreviewModal(false);
  };

  const viewMyTechProfileButton = () => {
    return (
      <div className="grabCertificate_viewmyprofile_button-container">
        <button
          onClick={() => toggleDrawer(true)}
          className="grabCertificate_viewmyprofile_button-action primary-shimmer-button"
        >
          <div className="grabCertificate_viewmyprofile_button-content">
            <span>{userInfo?.firstName} Tech Portfolio</span>
            <div className="grabCertificate_viewmyprofile_button-arrow-icon">
              <RightArrowIcon />
            </div>
          </div>
        </button>

        <div className="grabCertificate_viewmyprofile_button-rollingText">
          <motion.span
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
          >
            {texts[index]}
          </motion.span>
        </div>
      </div>
    );
  };

  const renderCertificateButton = () => {
    if (hasCertificate) {
      // Show download button directly
      return (
        <button
          onClick={handleOpenDownloadDialog}
          className="grabcertificate-action-button download-certificate-button"
        >
          <div className="grabcertificate-button-content">
            <span>Download Your Certificate</span>
            <div className="grabcertificate-download-icon">
              <DownloadIcon />
            </div>
          </div>
          <div className="grabcertificate-free-badge">
            Already Earned • Free Download
          </div>
        </button>
      );
    }

    // Show payment button
    if (loading) {
      return <MySkeletonLoader height={"120px"} width={"90%"} />;
    }

    return (
      <button
        onClick={handleOpenDownloadDialog}
        className="grabcertificate-action-button secondary-button"
      >
        <div className="grabcertificate-button-content">
          <span>Get Your Certificate</span>
          <div className="grabcertificate-arrow-icon">
            <RightArrowIcon />
          </div>
        </div>
        <div className="grabcertificate-price-section">
          For just: {getCurrencySymbol(pricingOption?.options?.[0]?.currency)}
          {pricingOption?.options?.[0]?.price}{" "}
          <span className="grabcertificate-original-price">
            {getCurrencySymbol(pricingOption?.options?.[0]?.currency)}
            {pricingOption?.options?.[0]?.price +
              (pricingOption?.options?.[0]?.currency === "INR" ? 500 : 50)}
          </span>
        </div>
      </button>
    );
  };

  return (
    <div className="grabcertificate_main">
      <EducationTopBar
        logo={
          <div
            onClick={() => history.push("/")}
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <img
              className={
                isMobile ? "mobile-logo" : "grabcertificate_desktoplogo"
              }
              src="https://res.cloudinary.com/cqn/image/upload/v1740519381/white_acetechies_logo_vsdhp5.png"
              alt=""
            />
          </div>
        }
      />
      <div className="grabcertificate-page">
        <div className="grabcertificate-container">
          {/* Left Side */}
          <div className="grabcertificate-left">
            {/* Mobile: Show title and subtitle at top */}
            {isMobile && (
              <div className="grabcertificate-mobile-header">
                <h1 className="grabcertificate-title">
                  Congratulations,{" "}
                  <span className="gradient-text">{userInfo?.firstName}</span>{" "}
                  you have earned your certificate.
                </h1>
                <p className="grabcertificate-subtitle">
                  Unlock your Certificate of{" "}
                  <span className="gradient-text">
                    {data?.originalRegistration?.certification?.category?.title}
                  </span>
                  . You are in the{" "}
                  <span className="gradient-text">Top 10% of Developers</span>{" "}
                  to Complete this.
                </p>
              </div>
            )}

            <div className="grabcertificate-image-wrapper">
              <img
                src={certificateUrl || certificateImage}
                alt="Certificate Preview"
                className="grabcertificate-image"
              />
              <div className="grabcertificate-verified-chip">
                <VerifiedIcon />
                <span>Verified</span>
              </div>
              <div
                className="grabcertificate-overlay"
                onClick={handleOpenPreview}
              >
                <span>Preview Certificate</span>
                <RedirectIcon />
              </div>
            </div>

            <div>
              {/* Primary Button - Tech Portfolio */}
              {viewMyTechProfileButton()}

              {/* Certificate/Payment Button */}
              {renderCertificateButton()}
            </div>
          </div>

          {/* Right Side */}
          <div className="grabcertificate-right">
            {/* Desktop: Show title and subtitle */}
            {!isMobile && (
              <>
                <h1 className="grabcertificate-title">
                  Congratulations,{" "}
                  <span className="gradient-text">{userInfo?.firstName}</span>{" "}
                  you have earned your certificate.
                </h1>
                <p className="grabcertificate-subtitle">
                  Unlock your Certificate of{" "}
                  <span className="gradient-text">
                    {data?.originalRegistration?.certification?.category?.title}
                  </span>
                  . You are in the{" "}
                  <span className="gradient-text">Top 10% of Developers</span>{" "}
                  to Complete this.
                </p>
              </>
            )}

            <LinkedinTestimonialCarousel />

            <RecognizedBySection />
            <GrabCertificateHelpSection />
          </div>
        </div>
      </div>

      {/* Tech Profile Drawer */}
      <Drawer
        sx={{
          "& .MuiDrawer-paper": {
            width: { xs: "100%", md: "90%" },
            background: "#0a0a0f",
          },
        }}
        anchor="right"
        open={open}
        onClose={() => toggleDrawer(false)}
      >
        <div className="grabcertificate-banner">
          <div className="grabcertificate-banner-content">
            <div
              className="grabcertificate-close-icon"
              onClick={() => toggleDrawer(false)}
            >
              <CloseIcon sx={{ color: "#fff" }} />
            </div>
            <div className="grabcertificate-mode-container">
              <div
                style={{ border: "1px solid #ffd700" }}
                className="grabcertificate-mode-toggle grabcertificate-shimmer"
                onClick={() =>
                  history.push(
                    `/techprofile/edit/${CryptoJS.lib.WordArray.random(
                      16
                    ).toString()}`
                  )
                }
              >
                <svg
                  className="grabcertificate-edit-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                    fill="currentColor"
                  />
                </svg>
                <span>Edit Now</span>
              </div>
            </div>
          </div>
        </div>
        <div className="grabcertificate_techprofile_container">
          <MyTechProfile name={`${userInfo?.firstName}`} showPopup={true} />
        </div>
      </Drawer>

      {/* Download Certificate Modal */}
      <DownloadCertificateModal
        open={openDownloadDialog}
        onClose={handleCloseDownloadDialog}
        userName={userInfo?.firstName}
        certificateImage={certificateUrl || certificateImage}
        onDownload={handleDownloadCertificate}
      />

      {/* Certificate Preview Modal */}
      <CertificatePreviewModal
        open={openPreviewModal}
        onClose={handleClosePreview}
        certificateImage={certificateUrl || certificateImage}
        onDownloadClick={handleOpenDownloadDialog}
      />

      <PaymentLoader
        isOpen={isProcessing}
        minDuration={2000}
        onClose={() => {
          console.log("Payment processing UI closed");
        }}
      />
    </div>
  );
}

export default GrabCertificate;
